module.exports = __webpack_public_path__ + "qr3.d30e8963.png";